import items from "./items";
import notes from "./notes";
import table from "./table";
import history from "./history";
import login from "./login";

export default {
    items,
    notes,
    table,
    history,
    login
};
